<template>
	<!-- <transition name="el-zoom-in-top"> -->
	<div class="content-wrapper">
		<!-- Main content -->
		<section class="content">
			<div class="box">
				<div class="heading-cart cf">
					<h1>Publishers</h1>
					<router-link :to=" `${'/admin/publisher/add/'}`">Add Publisher</router-link>
				</div>
				 <!-- <el-button :plain="true" @click="dialogFormVisible = true">open a Form nested Dialog</el-button> -->
				 <el-dialog title="" :visible.sync="dialogFormVisible">
						<div>
							 <el-header>
									<div class="box-header">
										 <div class="box-tools pull-right">
										 </div>
									</div>
											<el-col :span="8" :offset="9">
												<p class = "headingName">&nbsp;Add Publisher to Automatad</p>
										 </el-col>
							 </el-header>
							 <el-main>
									<el-row :gutter="20">

									</el-row>
									<!-- <hr> -->
									<div class="">
										 <el-row :gutter="18">
												<el-col :span="6" :offset="6">
													<p class = "paragraphBold">Name</p>
													 <el-input placeholder="Please input" v-model="input"></el-input>
												</el-col>
													<el-col :span="6">
														<p class = "paragraphBold">Add Publisher</p>
													 <el-input placeholder="Please input" v-model="input"></el-input>
												</el-col>
										 </el-row>
										<el-row :gutter="18">
												<el-col :span="6" :offset="6">
													<p class = "paragraphBold">Name</p>
													 <el-input placeholder="Please input" v-model="input"></el-input>
												</el-col>
													<el-col :span="6">
														<p class = "paragraphBold">Add Publisher</p>
													 <el-input placeholder="Please input" v-model="input"></el-input>
												</el-col>
										 </el-row>
											<el-row :gutter="18">
												<el-col :span="6" :offset="6">
													<p class = "paragraphBold">Name</p>
													 <el-input placeholder="Please input" v-model="input"></el-input>
												</el-col>
													<el-col :span="6">
														<p class = "paragraphBold">Add Publisher</p>
													 <el-input placeholder="Please input" v-model="input"></el-input>
												</el-col>
										 </el-row>

									</div>
									<el-col :span="8" :offset="16" class = "buttonMargin">
										 <el-button @click="dialogFormVisible = false">Cancel</el-button>
										 <el-button type="primary" @click="dialogFormVisible = false">Confirm</el-button>
									</el-col>
							 </el-main>
							 <!-- /.box-body -->
						</div>
				 </el-dialog>
				 <ul class="cart-items width-100 pull-left pl-60 pr-30 pb-0 pt-0 container-fluid">
						<li class="cart-items-labels visible-lg-block visible-md-block row">
							 <span class="col-md-6 text-muted small">Publisher</span>
							 <!-- <span class="col-md-2 text-muted small text-center">quantity</span>  -->
							 <!-- <span class="col-md-4 text-muted small text-right">price</span> -->
						</li>
						<li v-for="option in publishers" class="row">
							 <span class="cart-image col-xs-12 col-sm-12 col-md-2">
									<router-link :to=" `${'/admin/publisher-info/' + option.uuid + '/' + option.id}`" class="h5" >
										<avatar class = "" :username="option.name" :size='50' color="#fff"></avatar>
										<!-- <img alt="product description" src="http://thymetheme.pl/vega/v102/assets/img/products/product-03.jpg"> -->
											
										</router-link>
							 </span>
							 <div class="cart-item-right col-md-10 col-xs-12 col-sm-12">
									<div class="row">
										 <span class="cart-description col-xs-12 col-md-5">
												<router-link :to=" `${'/admin/publisher-info/' + option.uuid + '/' + option.id}`" class="h5" >{{`${option.name}`}}</router-link>
												<!-- <span class="cart-item-price h5 text-muted">$ 33.00</span> -->
										 </span>
										 <span class="col-md-5 col-sm-12 text-right">
												<!-- <span class="cart-price pull-right">$330.00 <a class="cart-remove" href="#"> -->
												<router-link :to=" `${'/admin/publisher/edit/' + option.uuid + '/'}`" class ="hoverColor"><span class="ti-pencil-alt pull-right mt-5 ml-10">
													 </span>
												</router-link>
										 </span>
										 </span>
									</div>
							 </div>
						</li>
				 </ul>
				 <div style="clear:both"></div>
			</div>
		</section>
		<!-- /.content -->
	</div>
	<!-- </transition> -->
</template>
<script>

	 import axios from 'axios'
	 import Avatar from 'vue-avatar'
	 export default {

		 data () {
			 return {
				 name: 'ShopHome',
				 publishers: [],
				 dialogTableVisible: false,
				 dialogFormVisible: false,
				 form: {
					 name: '',
					 region: '',
					 date1: '',
					 date2: '',
					 delivery: false,
					 type: [],
					 resource: '',
					 desc: ''
				 },
				 formLabelWidth: '120px'
			 }
		 },  
		 beforeCreate: function () {
			 this.$nextTick(function () {
				 axios.get(BASE_URL + 'v1/publishers/')
					 .then(response => {
						 this.publishers = response.data
					 })
					 .catch(error => {
						 if (error.response.status == 400) {
							 if (error.response.data) {
								 console.log(error.response.data)
							 }
						 }
					 })
			 })
		 },
		 methods: {
	 
		 },
	components: {
		Avatar
	} 
}
</script>
<style scoped>
	 .hoverColor {
	 color: #000;
	 }
	 #app > div > div.content-wrapper > section.content > div > div.el-dialog__wrapper > div {
	 height: 100%;
	 width: 100%; 
		top:0px !important; 
		bottom: 0px !important; overflow: hidden;
			position: fixed;
	 }
	 .el-button {
		border-radius: 20px !important;
	 }
.headingName{
	font-size: 20px;
	font-weight: 500;
}
.paragraphBold{
	margin-top:1em;
}
.buttonMargin{
	margin-top: 2em;
}
.el-dialog__wrapper {
 
}
.content-wrapper .content{
	padding-top: 95px;
}
</style>


// WEBPACK FOOTER //
// Publisher.vue?89cdde04